import { render } from "./LabelCategories.vue?vue&type=template&id=005aff9e&scoped=true"
import script from "./LabelCategories.vue?vue&type=script&lang=js"
export * from "./LabelCategories.vue?vue&type=script&lang=js"

import "./LabelCategories.vue?vue&type=style&index=0&id=005aff9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005aff9e"]])

export default __exports__